import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSnackbar } from '../snackbar/useAppSnackbar';

const LogoutPage: React.FC = () => {
  const navigate = useNavigate();
  const { showSnackbar } = useAppSnackbar();

  useEffect(() => {
    showSnackbar({ message: 'ログアウトしました', severity: 'success' });
    navigate('/login', { replace: true });
  }, [navigate, showSnackbar]);

  return null;
};

export default LogoutPage;
